import './css/index.css';
import React from 'react';
import { render } from 'react-dom';
import Component from './component';

export default class {

    static name = 'chart-line-partisan';

    constructor( config ) {

        Object.assign( this, config );

        this.pageWrapper = document.querySelector( '.page' );
        this.saveButton = this.pageWrapper.querySelector( 'button.download-png' );

    }

    ready() {

        render(
            <Component
                pageWrapper={ this.pageWrapper }
                componentWrapper={ this.element }
                saveButton={ this.saveButton }
                data={ this.attributes.data }
                chart={ this.attributes.chart }
                downloadUrl={ this.attributes.file }
                disclaimer={ this.attributes.disclaimer }
                overlay={ this.attributes.overlay }
            />, this.element
        );

    }

}
